import React from "react";
import {INavigationItem} from "../../../interfaces/navigationBar/INavigationBar";



const ClassicNavigationBar = ({navigationItems}:{navigationItems: INavigationItem[]}) => {
    if (!navigationItems.length) return null;

    return (
        <nav id="classic-navigation-container" className="classic-navigation-container" aria-label="Navigate each tab">
            <ol className="classic-navigation-bar">
                {navigationItems.map((navItem: INavigationItem, index: number) => {

                    return (
                        <li key={index} className="classic-navigation-item">
                            <button
                                type="button"
                                className={`classic-navigation-button ${navItem.isSelected ? "selected-navigation-item":""}`}
                                onClick={() => {
                                    navItem.onClick?.();
                                    }
                                }
                            >
                                {navItem.title}
                            </button>
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
};

export default ClassicNavigationBar;